import e from "react";
import { getIconColor as n } from "./iconfont.es5470.js";
import v from "./iconfont.es5471.js";
const i = {
  display: "block"
}, f = ({ size: o = 16, useVw: l, useRem: t, color: c, withColor: r, removeClassName: d, disableSSR: m, style: a, ...p }) => {
  const h = a ? { ...i, ...a } : i;
  return /* @__PURE__ */ e.createElement(v, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "icon-24px-shezhiv31", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: l ? ((o || 0) / 375 * 100).toFixed(5) + "vw" : o + (t ? "rem" : "px"), height: l ? ((o || 0) / 375 * 100).toFixed(5) + "vw" : o + (t ? "rem" : "px"), className: d ? "" : "iconpark-icon", style: h, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: r ? n(c, 0, "currentColor") : "currentColor",
      datafollowfill: r ? n(c, 0, "currentColor") : "currentColor",
      d: "m7.253 18.965-3.776-6.42a1.075 1.075 0 0 1 0-1.09l3.776-6.42c.194-.328.546-.53.927-.53h7.64c.381 0 .733.202.927.53l3.776 6.42c.198.337.198.754 0 1.09l-3.776 6.42c-.194.329-.546.53-.927.53H8.18c-.381 0-.733-.201-.927-.53Zm-1.379.812a2.675 2.675 0 0 0 2.306 1.318h7.64c.948 0 1.825-.501 2.306-1.318l3.776-6.42a2.675 2.675 0 0 0 0-2.713l-3.776-6.42a2.675 2.675 0 0 0-2.306-1.319H8.18c-.948 0-1.825.502-2.306 1.319l-3.776 6.42a2.675 2.675 0 0 0 0 2.713l3.776 6.42ZM14.144 12a2.145 2.145 0 1 1-4.29 0 2.145 2.145 0 0 1 4.29 0Zm1.6 0a3.745 3.745 0 1 1-7.49 0 3.745 3.745 0 0 1 7.49 0Z",
      clipRule: "evenodd",
      fillRule: "evenodd"
    }
  )));
}, C = f;
export {
  C as default
};
